import styled from 'styled-components';

export const Container = styled.div`
  .text-secondary {
    color: #535a60 !important;
  }

  .bidding-info {
    overflow-wrap: anywhere;
  }

  .bidding-info-title {
    color: ${(props) => props.theme.$dark_slate_blue} !important;
    font-weight: bold;
  }

  .number-cnl {
    color: ${(props) => props.theme.$dark_slate_blue} !important;
  }

  .estimated {
    color: #ff8000 !important;
  }

  .notice-date {
    background-color: #f89f3e;
  }

  [class*='bidding-situation-'],
  .session-status {
    background-color: ${(props) => props.theme.$gray600};
    color: ${(props) => props.theme.$white};
    padding: 3px 7px;
  }

  .bidding-situation-nova {
    background-color: ${(props) => props.theme.$primary_green};
  }

  .bidding-situation-urgente {
    background-color: ${(props) => props.theme.$danger};
  }

  .bidding-situation-suspensa,
  .bidding-situation-suspensa-sine-die {
    background-color: ${(props) => props.theme.$warning};
    color: ${(props) => props.theme.$black};
  }

  .meta {
    font-size: 12px;
  }
`;
